export type StyleOptionsGermanVisibility = {
    textColor: true;
    titleColor: true;
    backgroundColor: true;
};
